// src/app/store/unsavedChangesStore.ts
import { create } from 'zustand';

interface UnsavedChangesState {
  isDirty: boolean;
  pendingNavigation: (() => void) | null;
  setIsDirty: (isDirty: boolean) => void;
  setPendingNavigation: (callback: (() => void) | null) => void;
  reset: () => void;
}

export const useUnsavedChangesStore = create<UnsavedChangesState>((set) => ({
  isDirty: false,
  pendingNavigation: null,
  setIsDirty: (isDirty: boolean) => set({ isDirty }),
  setPendingNavigation: (callback: (() => void) | null) => set({ pendingNavigation: callback }),
  reset: () => set({ isDirty: false, pendingNavigation: null }),
}));
